import React, { useMemo } from 'react'

import LegacyNextStep from 'common/builder/components/chart/FlowChart/nodes/shared/NextStep'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { FlowChartNextStep } from 'common/builder/components/chart/FlowChart/types/FlowChartNextStep'

interface NextStepProps {
  nextStep: FlowChartNextStep
  connectorOffsetX?: number
  style?: React.CSSProperties
}

export const NextStep = ({ nextStep, connectorOffsetX, style }: NextStepProps) => {
  const combinedStyle = useMemo(() => ({ ...sharedStyles.nextStep, ...style }), [style])
  return (
    <LegacyNextStep
      key={nextStep.id}
      sourceId={nextStep.id}
      disabled={nextStep.disabled}
      style={combinedStyle}
      dotColor={nextStep.color}
      text={nextStep.label === undefined ? '' : nextStep.label}
      connectorOffsetX={connectorOffsetX}
      tooltip={nextStep.tooltip}
    />
  )
}
